export default "__VITE_ASSET__CdGCi6hP__"